var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "market-accordion-container" },
    [
      _c("accordion", {
        class: _vm.block.accordion_color,
        attrs: {
          items: _vm.block.steps,
          "selector-background": "bg-white-with-lines"
        },
        scopedSlots: _vm._u([
          {
            key: "accordion-selector-title",
            fn: function(ref) {
              var item = ref.item
              return [
                _c("span", {
                  staticClass: "title",
                  domProps: { innerHTML: _vm._s(item.title) }
                })
              ]
            }
          },
          {
            key: "accordion-item-header-title",
            fn: function(ref) {
              var item = ref.item
              var itemIndex = ref.itemIndex
              return [
                _c("div", { staticClass: "title" }, [
                  _c("span", {
                    staticClass: "number large-number text-outline",
                    domProps: {
                      innerHTML: _vm._s(_vm.getFormattedNumber(itemIndex))
                    }
                  }),
                  _vm._v(" "),
                  _c("span", {
                    staticClass: "text",
                    domProps: { innerHTML: _vm._s(item.title) }
                  })
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "expanded-title" }, [
                  _vm._v("\n                Step "),
                  _c("span", {
                    staticClass: "number",
                    domProps: { innerHTML: _vm._s(itemIndex + 1) }
                  }),
                  _vm._v(" "),
                  _c("span", {
                    staticClass: "text",
                    domProps: { innerHTML: _vm._s(item.title) }
                  })
                ])
              ]
            }
          },
          {
            key: "accordion-item-content",
            fn: function(ref) {
              var item = ref.item
              var itemIndex = ref.itemIndex
              return [
                _c("div", { staticClass: "container" }, [
                  _c("div", { staticClass: "process" }, [
                    _c("div", { staticClass: "process-step" }, [
                      _c("div", { staticClass: "header-image" }, [
                        item.add_background_overlay
                          ? _c("div", {
                              staticClass: "overlay",
                              style: {
                                opacity: item.background_overlay_opacity
                              }
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _c("img", { attrs: { src: item.header_image.url } })
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "content bg-dark-blue" }, [
                        _c("div", { staticClass: "flex" }, [
                          _c("div", { staticClass: "col" }, [
                            _c("div", {
                              staticClass: "roboto-mono number text-outline",
                              domProps: {
                                innerHTML: _vm._s(
                                  _vm.getFormattedNumber(itemIndex)
                                )
                              }
                            })
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "col" }, [
                            item.content.top_title
                              ? _c("div", {
                                  staticClass: "top-title",
                                  domProps: {
                                    innerHTML: _vm._s(item.content.top_title)
                                  }
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            item.content.title
                              ? _c("h2", {
                                  staticClass: "title",
                                  domProps: {
                                    innerHTML: _vm._s(item.content.title)
                                  }
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            item.content.copy
                              ? _c("div", {
                                  staticClass: "copy",
                                  domProps: {
                                    innerHTML: _vm._s(item.content.copy)
                                  }
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            item.content.button
                              ? _c("div", { staticClass: "button-container" }, [
                                  _c("a", {
                                    staticClass: "hover-button orange",
                                    attrs: {
                                      href: item.content.button.url,
                                      target: item.content.button.target
                                    },
                                    domProps: {
                                      innerHTML: _vm._s(
                                        item.content.button.title
                                      )
                                    }
                                  })
                                ])
                              : _vm._e()
                          ])
                        ])
                      ])
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "process-highlights" },
                      _vm._l(item.highlights, function(highlight, index) {
                        return _c(
                          "div",
                          { key: index, staticClass: "highlight" },
                          [
                            item.content.top_title
                              ? _c("div", {
                                  staticClass: "top-title",
                                  domProps: {
                                    innerHTML: _vm._s(highlight.top_title)
                                  }
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            item.content.title
                              ? _c("h2", {
                                  staticClass: "title",
                                  domProps: {
                                    innerHTML: _vm._s(highlight.title)
                                  }
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            item.content.copy
                              ? _c("div", {
                                  staticClass: "copy",
                                  domProps: {
                                    innerHTML: _vm._s(highlight.copy)
                                  }
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            highlight.button
                              ? _c("div", { staticClass: "button-container" }, [
                                  _c("a", {
                                    staticClass: "hover-button orange",
                                    attrs: {
                                      href: highlight.button.url,
                                      target: highlight.button.target
                                    },
                                    domProps: {
                                      innerHTML: _vm._s(highlight.button.title)
                                    }
                                  })
                                ])
                              : _vm._e()
                          ]
                        )
                      }),
                      0
                    )
                  ])
                ])
              ]
            }
          }
        ])
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }